// extracted by mini-css-extract-plugin
module.exports = {"categories":"n_8","categoriesHeadline":"n_9 f_s","category":"n_bb"};